import { useAuth as useAuthContext } from '@/contexts/AuthContext';

/**
 * Compatibility hook.
 *
 * This project historically had BOTH a local-state `useAuth` hook and an
 * `AuthContext`. Multiple hook instances caused "logout doesn't work" bugs,
 * because different parts of the app could keep different auth state.
 *
 * We now delegate to the single shared AuthContext so auth state is consistent
 * everywhere.
 */
export const useAuth = () => {
  const { user, loading, signOut } = useAuthContext();

  // Keep the old shape for any existing imports.
  return { user, session: null, loading, signOut };
};
